import * as React from 'react'
import { History } from 'history'
import UIMessages from '../../../utils/ui-messages'
import history from 'src/history'

interface IProps {
  cancelPath: string
  isSaving: boolean
  onSave?: () => void
  history?: History
  disabled?: boolean
}

const EditProductBottomBar = ({ cancelPath, isSaving, onSave, disabled }: IProps) => {
  const saveButtonText = isSaving ? UIMessages.common.saving : UIMessages.common.save
  const handleRedirect = (path: string) => {
    if (history) {
      history.push(path)
    }
  }

  const saveHandle = () => {
    if (onSave) {
      onSave()
    }
  }
  return (
    <div className='flex absolute bottom-0 flex items-center justify-end bg-light-grey7 px2 py1 w100 z1'>
      <div className='mr3'>
        <button
          aria-label={`cancel`}
          className='custom-btn mbsc-flat-white-btn mr2'
          onClick={() => handleRedirect(cancelPath)}
        >
          {UIMessages.common.cancel}
        </button>
        {onSave && disabled !== true ? (
          <button aria-label='Save changes' className='custom-btn mbsc-success-btn' onClick={saveHandle}>
            {saveButtonText}
          </button>
        ) : (
          <button aria-label='Save changes' className='custom-btn mbsc-flat-btn'>
            {saveButtonText}
          </button>
        )}
      </div>
    </div>
  )
}

export default EditProductBottomBar



// WEBPACK FOOTER //
// ./src/components/vehicles/edit-vehicle/EditBottom.tsx